import React from "react";
import "./ConfirmationModal.css";
import { FaExclamationTriangle } from "react-icons/fa";

const ConfirmationModal = ({ isOpen, onClose, onConfirm, title, message }) => {
  if (!isOpen) return null;

  return (
    <div className="modal-overlay">
      <div className="modal-content">
        <FaExclamationTriangle style={{ fontSize: '2.5rem', color: 'var(--cor-erro)', marginBottom: '1rem' }} />
        <h2>{title}</h2>
        <p>{message}</p>
        <div className="modal-actions">
          <button onClick={onClose} className="button-secondary btn-modern" style={{ minWidth: 120 }}>
            Cancelar
          </button>
          <button onClick={onConfirm} className="btn-modern" style={{ background: 'var(--cor-erro)', minWidth: 120 }}>
            Confirmar
          </button>
        </div>
      </div>
    </div>
  );
};

export default ConfirmationModal;
